import Vue from 'vue'
import store from './store'
import router from './router'
import Notify from 'quasar/src/plugins/Notify.js';

const interceptor = (http) => {
  http.interceptors.request.use(request => {
    Vue.prototype.$Progress.start()
    const token = store.getters.getToken
    if (token) {
      request.headers['Authorization'] = token
    }
    return request
  }, error => {
    Vue.prototype.$Progress.fail()
    Promise.reject(error)
  })

  http.interceptors.response.use(response => {
    Vue.prototype.$Progress.finish()
    return response
  }, error => {
    Vue.prototype.$Progress.fail()
    if (error.response.status === 401) {
      store.dispatch('setUsuario', {})
      store.dispatch('setToken', '')
      Notify.create({
        message: error.response.data,
        color: 'orange',
        position: 'top-right',
        icon: 'report_problem'
      })
      if (router.history.current.name !== 'Login') {
        router.push({ name: 'Login' })
      }
    }
    return Promise.reject(error)
  })
}

export default interceptor